import { useLocation } from 'react-router-dom';

const useRouterQuery = () => new URLSearchParams(useLocation().search);

export default useRouterQuery;
